import * as S from "./styles";
interface Props {
  leftClick: React.MouseEventHandler<HTMLButtonElement>;
  response: boolean;
  rightClick: React.MouseEventHandler<HTMLButtonElement>;
  label: string;
  isPerson: boolean;
}

export function ProviderToggleButton({
  label,
  leftClick,
  rightClick,
  isPerson,
}: Props) {
  return (
    <S.ToggleContainer>
      <label>{label}</label>
      <S.ToggleButton>
        <S.Button type="button" onClick={leftClick} isPerson={isPerson}>
          Pessoa física
        </S.Button>
        <S.Button type="button" onClick={rightClick} isPerson={!isPerson}>
          Pessoa jurídica
        </S.Button>
      </S.ToggleButton>
    </S.ToggleContainer>
  );
}
